import React, { useEffect } from "react";
import { PhoneNumberPriceInterface } from "src/store/callrecorder/phoneNumberPricesSlice";

import { Button, Form, Input, InputNumber, Switch } from "antd";

interface propsInterface {
  params?: PhoneNumberPriceInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <h6 className="v-content-label o-sm">Sell Prices</h6>

      <Form.Item name='currency' label="Currency">
        <Input placeholder='USD' />
      </Form.Item>

      <Form.Item name='monthly_fee' label="Monthly Fee">
        <InputNumber placeholder='1.15' style={{ width: '100%' }} min={0} step={0.01} />
      </Form.Item>

      <Form.Item name='setup_fee' label="Setup Fee">
        <InputNumber placeholder='1.0' style={{ width: '100%' }} min={0} step={0.01} />
      </Form.Item>

      <Form.Item name='inbound_cost_per_min' label="Inbound Cost / Min">
        <InputNumber placeholder='0.0055' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <Form.Item name='inbound_sms_price' label="Inbound SMS Price">
        <InputNumber placeholder='0.005' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <Form.Item name='inbound_mms_price' label="Inbound MMS Price">
        <InputNumber placeholder='0.01' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <h6 className="v-content-label o-sm">Raw Provider Prices</h6>

      <Form.Item name='raw_monthly_fee' label="Raw Monthly Fee">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} min={0} step={0.01} />
      </Form.Item>

      <Form.Item name='raw_inbound_trunking_price' label="Raw Inbound Trunking Price">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <Form.Item name='raw_inbound_trunking_from_landline' label="Raw Trunking from Landline">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <Form.Item name='raw_inbound_trunking_from_mobile' label="Raw Trunking from Mobile">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <Form.Item name='raw_inbound_sms_price' label="Raw Inbound SMS Price">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <Form.Item name='raw_inbound_mms_price' label="Raw Inbound MMS Price">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} min={0} step={0.0001} />
      </Form.Item>

      <h6 className="v-content-label o-sm">Capabilities</h6>

      <Form.Item label="SMS Enabled" name='sms_enabled' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="MMS Enabled" name='mms_enabled' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Trunking Enabled" name='trunking_enabled' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Address Required" name='address_required' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Beta" name='beta' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Domestic Voice Only" name='domestic_voice_only' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Domestic SMS Only" name='domestic_sms_only' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
